import { ArrowLeft, CircleX } from "lucide-react";
import { Link } from "react-router-dom";
import styles from "./PaymentFailture.module.css";

function PaymentFailure() {
    return (
        <main className={styles.page}>
            <section className={styles.panel} aria-labelledby="payment-failure-title">
                <div className={styles.statusIcon} aria-hidden="true">
                    <CircleX strokeWidth={1.75} />
                </div>

                <p className={styles.eyebrow}>Payment unsuccessful</p>
                <h1 id="payment-failure-title">Sorry, that didn&apos;t go through.</h1>
                <p className={styles.message}>
                    Your payment could not be processed. No charge was completed, so you
                    can safely return to checkout and try again.
                </p>

                <Link className={styles.retryButton} to="/checkout">
                    <ArrowLeft size={18} aria-hidden="true" />
                    Return to checkout
                </Link>

                <p className={styles.helpText}>
                    Still having trouble? Try a different payment method or contact your
                    card provider.
                </p>
            </section>
        </main>
    );
}

export default PaymentFailure;